import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
export default {
  name: 'TheSorts',
  props: {
    inlined: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      methods: [{
        key: 'popular',
        sortBy: 'popular',
        orderBy: null
      }, {
        key: 'publishdate',
        sortBy: 'publishdate',
        orderBy: null
      }, {
        key: 'priceAscending',
        sortBy: 'price',
        orderBy: 'asc'
      }, {
        key: 'priceDescending',
        sortBy: 'price',
        orderBy: 'desc'
      }],
      selected: {
        key: 'popular',
        sortBy: 'popular',
        orderBy: null
      }
    };
  },

  methods: _objectSpread({}, mapMutations({
    sortBy: 'pageActions/SORT_BY',
    orderBy: 'pageActions/ORDER_BY'
  }), {
    tracking(e) {
      const events = [{
        method: 'popular',
        event: 'Tri_Pertinence'
      }, {
        method: 'publishdate',
        event: 'Tri_Nouveaute'
      }, {
        method: 'priceAscending',
        event: 'Tri_Croissant'
      }, {
        method: 'priceDescending',
        event: 'Tri_Decroissant'
      }];
      const action = events.find(entry => entry.method === this.selected.key).event;
      const tag = {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: action,
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
      this.$root.$emit('generic-tracking', e, tag);
    },

    isActive(arg) {
      return arg === this.selected.key;
    }

  })
};